import { createContext } from 'react';
import type { AspNetRolesMenuItemsPermissions_EXT, Items } from '../../Models/Classes';

export interface LoadingState {
    items: boolean;
    permissions: boolean;
    userRole: boolean;
}

export interface PermissionContextType {
    permissions: AspNetRolesMenuItemsPermissions_EXT[];
    items: Items[];
    userRole: string;
    loading: LoadingState;
    errors: Partial<LoadingState>;
    pageID: string;
    setPageID: (pageID: string) => void;
    setPermissions: (permissions: AspNetRolesMenuItemsPermissions_EXT[]) => void;
    setItems: (items: Items[]) => void;
    setUserRole: (userRole: string) => void;
}

export const PermissionContext = createContext<PermissionContextType | undefined>(undefined);
